

























import { Component, Vue, Watch } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
import api from '@/api';
import slugify from '@/slugify';

@Component({
  components: {
    HelloWorld,
  },
})
export default class Home extends Vue {
  private results: any = [];
  private query: string = '';
  private loading: boolean = false;
  private slugify = slugify;
  private mounted() {
    this.search();
  }
  private search() {
    if (!this.query) {
      return;
    }
    this.loading = true;
    api(`https://itunes.apple.com/search?term=${encodeURIComponent(this.query)}&limit=5`)
      .then((result) => {
        this.results = result;
      })
      .then(() => this.loading = false);
  }
  @Watch('query')
  private onQueryChanged(val: string) {
    this.search();
  }
}
